import PopularCTA from "../components/PopularCTA"

const Registration =()=>{
    return(
        <>
        {<PopularCTA/>}
        </>
    )
}
export default Registration